// Shared display formats for the console. Money is Omani rials to the baisa
// (3 decimals); times are Oman time whatever the viewer's computer is set to.
const OMAN = "Asia/Muscat";

export const formatOMR = (value) =>
  `${(Number(value) || 0).toLocaleString("en-US", { minimumFractionDigits: 3, maximumFractionDigits: 3 })} OMR`;

export const formatCount = (value) => (Number(value) || 0).toLocaleString("en-US");

export const formatDateTime = (value) =>
  value
    ? new Date(value).toLocaleString("en-GB", {
        timeZone: OMAN,
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "—";

export const formatDate = (value) =>
  value
    ? new Date(value).toLocaleDateString("en-GB", { timeZone: OMAN, day: "numeric", month: "short", year: "numeric" })
    : "—";

// Today's date in Oman, as YYYY-MM-DD (what date inputs use).
export const omanToday = () => new Date().toLocaleDateString("en-CA", { timeZone: OMAN });

// Order numbers made by the app already start with "#".
export const orderLabel = (orderNumber) => {
  const value = String(orderNumber ?? "");
  return value.startsWith("#") ? value : `#${value}`;
};

// What each order status means, in the words the apps use.
export const ORDER_STATUS = {
  PENDING: { label: "Waiting for the shop", palette: "orange" },
  ACCEPTED: { label: "Accepted", palette: "blue" },
  PREPARING: { label: "Preparing", palette: "blue" },
  READY: { label: "Ready", palette: "blue" },
  OUT_FOR_DELIVERY: { label: "On the way", palette: "purple" },
  DELIVERED: { label: "Delivered", palette: "green" },
  CANCELLED: { label: "Cancelled", palette: "red" },
  REJECTED: { label: "Rejected by the shop", palette: "red" },
};

export const PAYMENT_METHOD = {
  // The buyer pays the shop on delivery, by cash or on the shop's card machine.
  CASH: "On delivery (cash or card)",
  CARD: "Card",
  WALLET: "Wallet",
  ONLINE: "Online",
};

// "Paid", or for payment still to be collected on delivery, "To collect".
export const paymentState = (order) => {
  if (order?.paymentStatus === "PAID") return "Paid";
  if (order?.paymentStatus === "REFUNDED") return "Refunded";
  if (order?.paymentStatus === "FAILED") return "Payment failed";
  if (order?.status === "CANCELLED" || order?.status === "REJECTED") return "Not charged";
  return order?.paymentMethod === "CASH" ? "To collect" : "Not paid yet";
};
